import React, { useState, useEffect, useRef } from "react";
import InputTextElementElement from "../../../../../Components/UiComponents/InputTextElement";
import DropdownElement from "../../../../../Components/UiComponents/DropdownElement";
import ButtonElement from "../../../../../Components/UiComponents/ButtonElement";
import { useForm, Controller } from "react-hook-form";
import ToastElement from "../../../../../Components/UiComponents/ToastElement";
import TextareaElement from "../../../../../Components/UiComponents/TextareaElement";
import MultiSelectElement from "../../../../../Components/UiComponents/MultiSelectElement";
import CalendarElement from "../../../../../Components/UiComponents/CalendarElement";
import DataTable from "../../../../../Components/UiComponents/DataTable";
import _, { range } from "lodash";
// Services
import {
  get,
  saveCRDScoreBox,
  update,
  getLogsTable,
  createLogs,
  getCustomerDetails,
} from "../../../../../Services/clientService";
import {
  pendingCliNotifications,
  reThrowNotification,
} from "../../../../../Services/notificationService";
import { Dialog } from "primereact/dialog";
import ExcelUploader from "./excelUploader";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Tooltip } from "primereact/tooltip";
import Moment from "moment";
import socket from "../../../../../socket";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../../Components/Videos/PlaylistVideos";

const EsgPreviewScore = (props) => {
  const clientDataRef = useRef();
  const [field, setField] = useState({});
  const [rdsData, setRdsData] = useState();
  const { register, handleSubmit, setValue, getValues, watch, control } =
    useForm();
  const formValues = watch();
  const [fields, setFields] = useState([]);
  const [criteriaFields, setCriteriaFields] = useState([]);
  const [dropdownDetails, setDropdownDetails] = useState([]);
  const [people, setPeople] = useState({});
  const [ourPeople, setOurPeople] = useState({});
  const [relatioshipWithClient, setRelatioshipWithClient] = useState({});
  const [contactWithClient, setContactWithClient] = useState({});
  const [decisionMaker, setDecisionMaker] = useState({});
  const [services, setServices] = useState({});
  const [speedPayment, setSpeedPayment] = useState({});
  const [clientPlan, setClientPlan] = useState({});
  const [deliveryPerformance, setDeliveryPerformance] = useState({});
  const [complaintsLastYear, setComplaintsLastYear] = useState({});
  const [winningWork, setWinningWork] = useState({});
  const [appropriatelyConducted, setAppropriatelyConducted] = useState({});
  const [caseStudy, setCaseStudy] = useState({});
  const [clientWork, setclientWork] = useState({});
  const [contact, setContact] = useState({});
  const [monitoringCompetitor, setMonitoringCompetitor] = useState({});
  const [monitoringProgress, setMonitoringProgress] = useState({});
  const [businessPlan, setBusinessPlan] = useState({});
  const [seeUs, setSeeUs] = useState({});
  const [risk, setRisk] = useState({});
  const [groupedData, setGroupedData] = useState({});
  const [score, setScore] = useState({});
  const [clientData, setClientData] = useState({});
  const [branch, setBranch] = useState(null);
  const [formData, setFormData] = useState({});
  const [uploadPopup, setUploadPopup] = useState(false);
  const [optionName, setOptionName] = useState();
  const [clientLogData, setClientLogData] = useState();
  const [allRdsData, setAllRdsData] = useState([]);
  const [historyPopup, setHistoryPopup] = useState(false);
  const [selectedHistoricData, setSelectedHistoricData] = useState({});
  const [allFormData, setAllFormData] = useState();
  const [dateTimeUpdated, setDateTimeUpdated] = useState(false);
  const [tooltipData, setTooltipData] = useState();
  const [newModule, setNewModule] = useState({});
  const [rdsTotal, setRdsTotal] = useState();
  const [selectedOptions, setSelectedOptions] = useState({});
  const [rdsUpdatedData, setRdsUpdatedData] = useState(null);
  const [loading, setLoading] = useState(false)
  const [showVideo, setShowVideo] = useState(false);
  const toastRef = useRef();
  const navigate = useNavigate()

  useEffect(() => {
    const grouped = groupData(props?.EsgPreviewScoreData?.clientFieldsRDS);
    setGroupedData(grouped);
    if (props) {
      let clientFields = props?.EsgPreviewScoreData?.clientFieldsRDS;

      setFields(props?.EsgPreviewScoreData?.clientSectionsSummary);
      setCriteriaFields(clientFields);
    }
  }, [props]);

  useEffect(() => {
    const userprivileges = localStorage.getItem("user_privileges");
    if (userprivileges) {
      const tmpPrivilege = JSON.parse(userprivileges);
      if (props?.EsgPreviewScoreData?.clientSectionsSummary && tmpPrivilege !== undefined && tmpPrivilege !== null) {
        let obj1 = _.find(props?.EsgPreviewScoreData?.clientSectionsSummary, {
          section_name: "Criteria",
        })?.display_name;
        let obj2 = _.find(props?.EsgPreviewScoreData?.clientSectionsSummary, {
          section_name: "Comments",
        })?.display_name;

        var combined = {}
        if (tmpPrivilege[0].stakeholder_comments) {
          combined = { obj1, obj2 };
        } else {
          combined = { obj1 };
        }
        setNewModule(combined);
      }
    }
  }, [props?.EsgPreviewScoreData?.clientSectionsSummary]);

  const removeSpecificKeys = (obj, keysToRemove) => {
    return Object.entries(obj)
      .filter(([key, _]) => !keysToRemove.includes(key))
      ?.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
  };

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  const getFunctionBasedOnObject = (obj) => {
    if (isEmpty(obj)) {
      return true;
    } else {
      return false;
    }
  };

  function normalizeFormValues(obj) {
    let result = {};
    for (let key in obj) {
      if (
        typeof obj[key] === 'object' &&
        obj[key] !== null &&
        !Array.isArray(obj[key]) &&
        !hasValidFields(obj[key])
      ) {
        const flattened = normalizeFormValues(obj[key]);
        for (let nestedKey in flattened) {
          result[`${key}.${nestedKey}`] = flattened[nestedKey];
        }
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  }

  function hasValidFields(obj) {
    const validFields = ["status", "_id", "options", "id", "text"];
    return validFields.some(field => field in obj);
  }

  function getFormValues() {
    const formValuesFunc = getFunctionBasedOnObject(formValues);
    const clientDataFunc = getFunctionBasedOnObject(clientData);

    if (!formValuesFunc && !clientDataFunc) {
      const normalizedFormValues = normalizeFormValues(formValues);

      normalizedFormValues.date = Moment(normalizedFormValues.date).format("DD-MM-YYYY");

      let resData = transformResponse(normalizedFormValues);
      const textInputKeys = allRdsData.filter((item) => item.field_type === "Text box").map((item) => item.field_name)
      const keysToRemove = ["date", "comments", ...textInputKeys];

      const cleanedData = removeSpecificKeys(resData, keysToRemove);

      if (cleanedData != null && clientData != null) {
        var data = Object.assign({}, clientData.rds.rds_data, cleanedData);
        clientData.rds.rds_data = data;
        props.getEsgData(clientData);
      }
    }
  }
  useEffect(() => {
    getFormValues();
  }, [formValues]);

  useEffect(() => {
    props.getTotalValue(rdsTotal);
  }, [rdsTotal]);
  useEffect(() => {
    getClientLogData();
  }, [props?.clientId]);
  useEffect(() => {
    saveCRDScoreBoxFun();
  }, [clientData]);

  useEffect(() => {
    if (props) {
      // Fetching end user data from local storage
      const enduserStr = localStorage.getItem("enduser");
      // Checking if end user data exists in local storage
      if (enduserStr) {
        // Parsing end user data
        const enduser = JSON.parse(enduserStr);
        // Extracting customer information from end user data
        const customer = enduser.customer;
        const branch = enduser.branch;
        // Setting customer ID state
        setBranch(branch);
      } else {
        navigate("/login")
        localStorage.clear()
      }

      let clientFields = props?.EsgPreviewScoreData?.clientFieldsRDS;
      setAllRdsData(clientFields);
      if (clientFields) {
        let score = clientFields?.filter(
          (item) => item.field_name === "Relationship Development Score"
        );

        setScore(score);
      }
    }
  }, [props]);

  const getClientLogData = async () => {
    setLoading(true);
    try {
      if (props?.clientId) {
        const res = await getLogsTable(props.clientId);

        // Check if response data exists
        if (res && res?.data) {
          setClientLogData(res.data);
        } else {
          toastRef.current.showToast({
            type: "warning",
            message: "No log data found for the specified client.",
          });
        }
      }
    } catch (error) {
      // Handle any errors during the API request
      toastRef.current.showToast({
        type: "error",
        message: "Failed to fetch client log data. Please try again or contact Admin."
      });
    } finally {
      setLoading(false);
    }
  };


  const groupData = (data) => {
    return data?.reduce((acc, item) => {
      const group = item.group || "Others"; // If no group, categorize under 'Others'
      if (!acc[group]) {
        acc[group] = [];
      }
      if (item?.field_status == true) {
        acc[group].push(item);
        return acc;
      } else {
        acc[group].push(item);
        return acc;
      }
    }, {});
  };

  useEffect(() => {
    getCustomerDetail();
  }, [props?.customerId]);

  useEffect(() => {
    getFieldData();
  }, [dropdownDetails]);
  useEffect(() => {
    if (branch) {
      cliData();
    }
  }, [props?.clientId, props?.customerId, branch]);

  const cliData = async () => {
    setLoading(true);

    try {
      // Check if required props are present
      if (props?.clientId && props?.customerId && branch) {
        const res = await get(props.clientId, props.customerId, branch);

        // Ensure response is valid and contains client data
        if (res?.data && res.data.client && res.data.client.length > 0) {
          const cliData = res.data.client[0];

          // Update state with client data
          setRdsData(cliData.rds);
          setClientData(cliData);
          setRdsTotal(cliData?.rds.total);
        } else {
          // Notify user if no client data is found
          toastRef.current.showToast({
            type: "warning",
            message: "No client data found for the provided ID."
          });
        }
      }
    } catch (error) {
      // Handle any errors during the API request
      toastRef.current.showToast({
        type: "error",
        message: "Failed to fetch client data. Please try again or contact Admin."
      });
    } finally {
      setLoading(false);
    }
  };


  const getCustomerDetail = async () => {
    try {
      setLoading(true); // Start loading spinner

      // Fetch customer details from the API
      const response = await getCustomerDetails(props?.customerId);

      // Update tooltip and dropdown details if the response is successful
      if (response && response?.data) {
        const clientModuleData = response.data.rds_data;
        setTooltipData(response.data.tooltips?.client.rds);
        setDropdownDetails(clientModuleData);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "No customer data found. Please check the customer ID.",
        });
      }
    } catch (error) {
      // Handle any errors that occur during the API request
      toastRef.current.showToast({
        type: "error",
        message: "Failed to fetch customer details. Please try again or contact Admin."
      });
    } finally {
      setLoading(false);
    }
  };


  const getFieldData = () => {
    const grouped = groupData(dropdownDetails);
    setField(grouped);
  };
  const handleInputChange = (key, value, Itemtype) => {
    setRdsUpdatedData((prev) => !prev);
    if (Itemtype && (Itemtype === "Text box" || Itemtype === "dropdown multi-select")) {
        const temp = props.clientData;
        if (!temp.rds?.rds_data){
          temp.rds['rds_data'] = {}
        }
        if (Itemtype === "dropdown multi-select") {
          temp.rds.rds_data[key] = Array.isArray(value) ? value.join(",") : "";
        } else {
            temp.rds.rds_data[key] = value;
        }
        
        // Delete the key if the value is an empty string or null
        if (temp.rds.rds_data[key] === "" || temp.rds.rds_data[key] === null) {
            delete temp.rds.rds_data[key];
        }
        props.setClientData(temp);
        setClientData(temp);
        setFormData((prevState) => ({
          ...prevState,
          [key]: value,
        }));
        setValue(key, value);
    } else {
        setFormData((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        setValue(key, value); // Update react-hook-form state
    }
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const transformResponse = (data) => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      acc[key] =
        typeof value === "object" && value !== null && "options" in value
          ? value.options
          : value;
      return acc;
    }, {});
  };

  // const updateData = async () => {
  //   try {
  //     setLoading(true)
  //     const response = await update(props?.customerId, clientData);
  //     setLoading(false)
  //     if (response?.data.success) {
  //       toastRef.current.showToast({
  //         type: "success",
  //         message: `myConsole,Stakeholder Updated Successfully`,
  //       });
  //     } else {
  //       toastRef.current.showToast({
  //         type: "error",
  //         message: response?.data?.message,
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const onClientSubmit = (data) => {
    // let resData = transformResponse(data)
    // // const updatedData = updateRdsData(clientData, resData);
    // if (resData) {
    //     let data = (clientData.rds.rds_data = resData);
    //     // updateData()
    // }
  };
  const onCloseUploadPopup = () => {
    setUploadPopup(false);
  };
  const onCloseHistoryPopup = () => {
    setHistoryPopup(false);
  };

  const setData = (option) => {
    setUploadPopup(true);
    setOptionName(option);
  };
  const checkingDate = (rowData) => {
    // Check if display name exists and is not empty
    if (
      rowData?.dataTimePeriod?.date != null &&
      rowData?.dataTimePeriod?.date !== ""
    ) {
      const date = new Date(rowData?.dataTimePeriod?.date);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return <div>{`${day}-${month}-${year}`}</div>;
    }
  };
  const checkingComments = (rowData) => {
    // Check if display name exists and is not empty
    if (
      rowData?.dataTimePeriod?.comments != null &&
      rowData?.dataTimePeriod?.comments !== ""
    ) {
      return <div>{rowData.dataTimePeriod.comments}</div>;
    }
  };
  const checkingESG = (rowData) => {
    // Check if display name exists and is not empty
    if (rowData?.rds?.total != null && rowData?.rds?.total !== "") {
      return <div>{rowData?.rds?.total}</div>;
    }
  };
  const columns = [
    // Column configuration for the "Question" field
    {
      field: "Date", // Data field to map from the row data
      header: "Date", // Header label for the column
      body: checkingDate, // Custom renderer for the cell content
      headerClassName: "header-datatable white-space",
      className: "row-datatable",
    },
    {
      field: "ESG Preview Score", // Data field to map from the row data
      header: "ESG Preview Score", // Header label for the column
      body: checkingESG, // Custom renderer for the cell content
      headerClassName: "header-datatable white-space",
      className: "row-datatable",
    },
    {
      field: "Comments", // Data field to map from the row data
      header: "Comments", // Header label for the column
      body: checkingComments, // Custom renderer for the cell content
      headerClassName: "header-datatable white-space",
      className: "row-datatable",
    },
  ];
  const removeField = async (selectedIndex, data) => { };

  const rowClick = async (data) => {
    setSelectedHistoricData(data);
    setHistoryPopup(true);
  };

  const saveCRDScoreBoxFun = async () => {
    try {
      // Save CRDScore
      if (
        props.EsgPreviewScoreData &&
        props.EsgPreviewScoreData.clientFieldsNew
      ) {
        // Finding the desired field
        const CRDScoreBoxCRDScore = _.find(
          props.EsgPreviewScoreData.clientFieldsNew,
          { field_name: "Current Relationship Development Score" }
        )?.field_name;
        // const CRDScoreBoxCRDScore = 'Current Relationship Development Score'
        if (dateTimeUpdated) {
          if (CRDScoreBoxCRDScore) {
            var ClientRDSLabel = CRDScoreBoxCRDScore.replace(/\&nbsp;/g, "");
            if (CRDScoreBoxCRDScore && ClientRDSLabel.trim().length > 0) {
              var CRDScoreBox = {
                winScoreLabel: { CRDScore: CRDScoreBoxCRDScore },
              };
              setLoading(true)
              const res = await saveCRDScoreBox(props?.customerId, CRDScoreBox);
              setLoading(false)
            }
            setLoading(true)
            if (clientData.bid_team.status_update != "status update") {
              clientData.bid_team.status_update_logs.push({ 'updates': clientData.bid_team.status_update + '\n On: ' + new Date().toLocaleDateString('en-CA') });
              const res = await createLogs(clientData);
              setLoading(false)
              if (res && res.data?.success === true) {
                toastRef.current.showToast({
                  type: "success",
                  message: res.data.message,
                });
                getClientLogData();
                setDateTimeUpdated(false);
              } else {
                toastRef.current.showToast({
                  type: "error",
                  message: res.data.message,
                });
              }
              setLoading(true)
              const pendingCliNotification = await pendingCliNotifications(
                clientData.customer_id,
                clientData._id
              );
              setLoading(false)
              if (pendingCliNotification && pendingCliNotification.data?.success === true) {
                getClientLogData();
                socket.emit('pushNotifications', clientData.customer_id)
              }
              let data = [];
              setLoading(true)
              const rThrowNotification = await reThrowNotification(data);
              setLoading(false)
              if (rThrowNotification && rThrowNotification.data?.success === true) {
                getClientLogData();
                socket.emit('pushNotifications', clientData.customer_id)
              }
            } else {
              const res = await createLogs(clientData);
              setLoading(false)
              if (res.data?.success === true) {
                toastRef.current.showToast({
                  type: "success",
                  message: res.data.message,
                });
                getClientLogData();
                setDateTimeUpdated(false);
              } else {
                toastRef.current.showToast({
                  type: "error",
                  message: res.data.message,
                });
              }
              setLoading(true)
              const pendingCliNotification = await pendingCliNotifications(
                clientData.customer_id,
                clientData._id
              );
              setLoading(false)
              if (pendingCliNotification && pendingCliNotification.data?.success === true) {
                getClientLogData();
                socket.emit('pushNotifications', clientData.customer_id)
              }
              let data = [];
              setLoading(true)
              const rThrowNotification = await reThrowNotification(data);
              setLoading(false)
              if (rThrowNotification && rThrowNotification.data?.success === true) {
                getClientLogData();
                socket.emit('pushNotifications', clientData.customer_id)
              }
            }
          }
        }
      }
    } catch (e) {
      toastRef.current.showToast({
        type: 'error',
        message: "An error occurred. Please try again or contact Admin.",
      });
    }
  };

  const gettingData = (item, e) => {

    let newValue = e?.value || e?.target?.value || (item?.type === "dropdown multi-select" && e);
    if (item?.type === "Numerical" && !newValue){
      newValue = 0
    }
    if (!newValue && newValue !== "" && newValue !== 0) return;
    const previousOption = selectedOptions[item._id];

    let total = rdsTotal;
    handleInputChange(item?.display_name, newValue, item.type);
    if (item.type === "Numerical") {
      let rangeId = null;

      // Determine the appropriate range id based on input value
      for (const option of item?.option_choice) {
        const [min, max] = option?.options?.split("-").map(Number);
        const inputValue = Number(newValue);

        if (inputValue >= min && inputValue <= max) {
          rangeId = option.id;
          break;
        }
      }

      if (rangeId !== null) {
        if (previousOption) {
          // Remove the previous selection's weight from the total
          total -= previousOption.id * item.weightage;
        }

        // Add the new selection's weight to the total
        total += rangeId * item.weightage;

        // setRdsTotal(total);
        // setRdsUpdatedData(item);

        // Update the selected option in the state
        setSelectedOptions((prev) => ({
          ...prev,
          [item._id]: { ...newValue, id: rangeId },
        }));
      }
    } else {
      if (
        (item?.weightage && item.type == "Percentage") ||
        item.type == "dropdown"
      ) {
        if (previousOption) {
          // Remove the previous selection's weight from the total
          total -= previousOption.id * item?.weightage;
        }

        // Add the new selection's weight to the total
        total += newValue.id * item?.weightage;

        // setRdsTotal(total);
        
        // Update the selected option in the state
        setSelectedOptions((prev) => ({
          ...prev,
          [item._id]: newValue,
        }));
      }
    }
   
    
  };

  useEffect(() => {
    updateRdsScore();
  }, [clientData?.rds?.rds_data, rdsUpdatedData]);


  useEffect(() => {
    clientDataRef.current = props.clientData
  }, [props.clientData])

  const updateRdsScore = () => {
    let score = 0;
    for (let [key, values] of Object.entries(field)){
      values.map((item) => {
        if(rdsData?.rds_data?.[item.display_name]){
          if (item?.option_choice && item?.weightage){
            item?.option_choice?.map((option) => {
              // Checking for Primary Question
              if (
                item.type === "dropdown multi-select"
                ? clientDataRef.current.rds?.rds_data?.[item.display_name]?.includes(option.options)
                : option.options === rdsData?.rds_data?.[item.display_name] && item?.type !== "Numerical"
              ) {
                score += item?.weightage * option.id;
              // Checking for sub Questions
              if (option.sub_questions.length > 0){
                option.sub_questions?.map((subQuestion) => {
                  subQuestion?.option_choice?.map((subOption) => {
                    // if (rdsData?.rds_data?.[subQuestion.display_name]?.includes(subOption.options) && subQuestion.type !== "Text box"){
                    if (Array.isArray(rdsData?.rds_data?.[subQuestion.display_name]) && rdsData.rds_data[subQuestion.display_name].includes(subOption.options) && subQuestion.type !== "Text box") {
                      score += subQuestion?.weightage * subOption?.id;
                    }
                  })
                })
              }
              }

            })
            if (item?.type === "Numerical"){
              let rangeId = null;
              let optionSelected = null
              // Determine the appropriate range id based on input value
              for (const option of item?.option_choice) {
                const [min, max] = option?.options?.split("-").map(Number);
                const inputValue = Number(rdsData?.rds_data?.[item.display_name]);
                if (inputValue >= min && inputValue <= max) {
                  rangeId = option?.id;
                  optionSelected =  option
                  break;
                }
              }
              if (rangeId) {
                score += rangeId * item?.weightage
              }
              // Checking for sub Questions
              if (optionSelected?.sub_questions?.length > 0){
                optionSelected?.sub_questions?.map((subQuestion) => {
                  subQuestion?.option_choice?.map((subOption) => {
                    if (rdsData?.rds_data?.[subQuestion?.display_name]?.includes(subOption?.options) && subQuestion?.type !== "Text box"){
                      score += subQuestion?.weightage * subOption?.id;
                    }
                  })
                })
              }

            }
          }
        }
      })
    }
    setRdsTotal(score);
  }


  const updateDataTimePeriod = (value) => {
    setClientData((prevState) => {
      const newState = {
        ...prevState,
        dataTimePeriod: value,
      };
      return newState;
    });
  };

  useEffect(() => {
    props.setClientData((prev)=>({
        ...prev,
        rds: {
          ...prev.rds,
          total: rdsTotal
        }
    }))
  }, [rdsTotal])

  const save = () => {
    setDateTimeUpdated(true);
    let data = updateDataTimePeriod(formValues);
  };

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Close"
            className="cancel-new-button"
            onClick={onCloseHistoryPopup}
          />
        </div>
      </div>
    );
  };

  const fileDownload = (url) => {
    if (url) {
      // Implement file download logic here
      window.location.href = url;
    } else {
      console.log("No file available to download");
    }
  };

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };

  return (
    <div>
      <ToastElement ref={toastRef} />
      <div className="col-md-12 text-right">
        <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      <form onSubmit={handleSubmit(onClientSubmit)}>
        {Object.entries(newModule).map(([key, value]) => (
          <div key={key} className="mt-10">
            <Accordion activeIndex={0}>
              {
                <AccordionTab header={value} disabled>
                  {key == "obj1" && (
                    <div className="new-field">
                      {Object.keys(field).map(
                        (key) =>
                          key !== "Others" && (
                            <div
                              key={key}
                              className="form-group row align-items-center mb-0 mt-20"
                            >
                              <div className="col-md-12 pl-0">
                                <p className="label-text">
                                  {capitalizeFirstLetter(key)}
                                </p>
                                {field?.[key]?.map((item, index) => {
                                  const defaultValue = (formData?.[item?.display_name]) || (rdsData?.rds_data ? rdsData.rds_data[item?.display_name] : undefined);
                                  var filteredOption = {};
                                  if (defaultValue) {
                                    filteredOption = item?.option_choice?.find(
                                      (option) =>
                                        option?.options === defaultValue
                                    );

                                    // Getting dropdown subquestions
                                    if (item.type === "dropdown multi-select"){
                                      filteredOption = item?.option_choice?.filter(
                                        (option) => {
                                          if (item?.display_name in formData){
                                            return formData?.[item.display_name]?.includes(option.options)
                                          }
                                          return defaultValue?.includes(option?.options)
                                        }
                                      )
                                      filteredOption = {sub_questions: filteredOption?.flatMap(item => item?.sub_questions)};
                                    }

                                    // Getting sub Questions for Numerical
                                    if (item.type === "Numerical"){
                                      for (const option of item?.option_choice) {
                                        const [min, max] = option?.options?.split("-").map(Number);
                                        const inputValue = Number(rdsData?.rds_data?.[item.display_name]);
                                        if (inputValue >= min && inputValue <= max) {
                                          filteredOption = option;
                                          break;
                                        }
                                      }
                                    }
                                    
                                  }

                                  return (
                                    <div
                                      key={index}
                                      className="form-group row align-items-center mb-0 mt-0"
                                    >
                                        <div className="col-md-5 pl-0">
                                          <label className="form-label text-left">
                                            {item?.display_name}
                                          </label>
                                        </div>

                                      <div className="col-md-1 pl-0">
                                        {tooltipData != undefined &&
                                          Object.entries(
                                            tooltipData?.criteria
                                          ).map(([key, value]) => {
                                            if (
                                              item.display_name ==
                                              value.ESG_field_name &&
                                              value.status == true
                                            ) {
                                              return (
                                                <div>
                                                  <Tooltip target=".custom-target-icon" />

                                                  <i
                                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                                    data-pr-tooltip={value.text}
                                                    data-pr-position="right"
                                                  ></i>
                                                </div>
                                              );
                                            }
                                          })}
                                      </div>
                                      {item?.flag_status ? (
                                        <div className="col-md-1 pl-0">
                                          <ButtonElement
                                            className="edit-option-button"
                                            type="button"
                                            icon="pi pi-upload"
                                            onClick={() =>
                                              setData(item.option_name)
                                            }
                                          />
                                        </div>
                                      ) : <div className="col-md-1 pl-0"></div>}
                                      {
                                        !_.isEmpty(item.file_path) ? (
                                          <div className="col-md-2 pl-0">
                                            <a className="form-label-text text-left mr-20 pointer mar-l-5 word-wrap" onClick={() => fileDownload(item.file_path.url)}>{item.file_path.fileName}</a>
                                          </div>
                                        ) : <div className="col-md-2 pl-0"></div>
                                      }
                                      <div className="col pr-0">
                                        {item.type === "dropdown" ||
                                          item.type === "Percentage" ? (
                                          <DropdownElement
                                            value={
                                              formData[item.display_name] ||
                                              filteredOption
                                            }
                                            onChange={(e) =>
                                              gettingData(item, e)
                                            }
                                            id={item.display_name}
                                            options={(item.option_choice != undefined && item.option_choice.length > 0) ? item.option_choice : []}
                                            optionLabel="options"
                                            placeholder="-- Please select --"
                                            className="w-full"
                                            />
                                        ) : item.type === "dropdown multi-select" ? (
                                          <MultiSelectElement
                                            value={
                                              typeof props.clientData?.rds?.rds_data?.[item.display_name] === "string"
                                              ? props.clientData?.rds?.rds_data?.[item.display_name].split(",").map(item => item.trim()) // Split and trim whitespace
                                              : props.clientData?.rds?.rds_data?.[item.display_name] || []
                                            }                                            
                                            optionLabel="label"
                                            options={item.option_choice && item.option_choice.length > 0 ? item?.option_choice?.map((item) => {
                                              return {
                                                label: item.options,
                                                value: item.options,
                                                id: item.id,
                                                status: item.status
                                              }
                                            }) : []}
                                            // options = {[{label: "Hello", value:"Hello" }, {label:"Hai", value:"hai"}]}
                                            placeholder="-- Please select --"
                                            // maxSelectedLabels={1}
                                            onChangeValue={(e) => gettingData(item, e.value)}
                                            className="w-full"
                                            />
                                        ) : item.type === "Text box" ? (
                                          <InputTextElementElement
                                            name={item.display_name}
                                            value={
                                              rdsData?.rds_data &&
                                              rdsData?.rds_data[
                                              item.display_name
                                              ]
                                            }
                                            onChange={(e) =>
                                              gettingData(item, e)
                                            }
                                            className="w-full"
                                          />
                                        ) : item.type === "Numerical" ? (
                                          <InputTextElementElement
                                            name={item?.display_name}
                                            value={
                                              formData?.[item.display_name] || (
                                              rdsData?.rds_data &&
                                              rdsData?.rds_data?.[
                                              item.display_name
                                              ])
                                            }
                                            onChange={(e) =>
                                              gettingData(item, e)
                                            }
                                            className="w-full"
                                            type='number'
                                          />
                                        ) : null}
                                      </div>
                                      {/* Sub Questions */}
                                      {((["dropdown multi-select", "Numerical"].includes(item?.type) && filteredOption) || formData?.[item.display_name] || filteredOption)?.sub_questions?.map((question) => {

                                        const defaultValue = rdsData?.rds_data
                                          ? rdsData.rds_data[question.display_name]
                                          : undefined;

                                        var filteredSubOption = {};
                                        if (defaultValue) {
                                          filteredSubOption = question.option_choice.find(
                                            (option) =>
                                              option.options === defaultValue
                                          );
                                        }
                                        return (
                                          <>
                                          <div className="col-md-6 pl-0 haha">
                                            <label className="form-label text-left">
                                              {question?.display_name}
                                            </label>
                                          </div>

                                          {item?.flag_status ? (
                                            <div className="col-md-1 pl-0">
                                              <ButtonElement
                                                className="edit-option-button"
                                                type="button"
                                                icon="pi pi-upload"
                                                onClick={() =>
                                                  setData(item.option_name)
                                                }
                                              />
                                            </div>
                                          ) : <div className="col-md-1 pl-0"></div>}
                                          {
                                            !_.isEmpty(item.file_path) && !question ? ( 
                                              <div className="col-md-2 pl-0">
                                                <a className="form-label-text text-left mr-20 pointer mar-l-5 word-wrap" onClick={() => fileDownload(item.file_path.url)}>{item.file_path.fileName}</a>
                                              </div>
                                            ) : <div className="col-md-2 pl-0"></div>
                                          }

                                          <div className="col pr-0">
                                            {question.type === "dropdown" ||
                                              question.type === "Percentage" ? (
                                              <DropdownElement
                                                value={
                                                  formData[question.display_name] ||
                                                  filteredSubOption
                                                }
                                                onChange={(e) =>
                                                  gettingData(question, e)
                                                }
                                                id={question.display_name}
                                                options={(question.option_choice != undefined && question.option_choice.length > 0) ? question.option_choice : []}
                                                optionLabel="options"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                />
                                            ) : question.type === "dropdown multi-select" ? (
                                              <MultiSelectElement
                                                value={
                                                  typeof props.clientData?.rds?.rds_data?.[question.display_name] === "string"
                                                  ? props.clientData?.rds?.rds_data?.[question.display_name].split(",").map(question => question.trim()) // Split and trim whitespace
                                                  : props.clientData?.rds?.rds_data?.[question.display_name] || []
                                                }                                            
                                                optionLabel="label"
                                                options={question.option_choice && question.option_choice.length > 0 ? question?.option_choice?.map((question) => {
                                                  return {
                                                    label: question.options,
                                                    value: question.options,
                                                    id: question.id,
                                                    status: question.status
                                                  }
                                                }) : []}
                                                // options = {[{label: "Hello", value:"Hello" }, {label:"Hai", value:"hai"}]}
                                                placeholder="-- Please select --"
                                                // maxSelectedLabels={1}
                                                onChangeValue={(e) => gettingData(question, e.value)}
                                                className="w-full"
                                                />
                                            ) : question.type === "Text box" ? (
                                              <>
                                              <InputTextElementElement
                                                name={question.display_name}
                                                value={
                                                  rdsData?.rds_data &&
                                                  rdsData?.rds_data[
                                                  question.display_name
                                                  ]
                                                }
                                                onChange={(e) =>
                                                  gettingData(question, e)
                                                }
                                                className="w-full"
                                              />
                                              </>
                                            ) : question.type === "Numerical" ? (
                                              <InputTextElementElement
                                                name={question.display_name}
                                                value={
                                                  rdsData?.rds_data &&
                                                  rdsData?.rds_data[
                                                  question.display_name
                                                  ]
                                                }
                                                onChange={(e) =>
                                                  gettingData(question, e)
                                                }
                                                className="w-full"
                                                type='number'
                                              />
                                            ) : null}
                                          </div>
                                          
                                          </>
                                        )
                                      })}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )
                      )}
                      <p className="label-text">Others</p>
                      {
                        <div className="form-group row align-items-center mb-0 mt-0">
                          <div className="col-md-9 pl-0">
                            <label className="form-label text-left">
                              {score[0]?.display_name || "ESG Preview Score"} :
                            </label>
                          </div>
                          <div className="col pr-0">
                            <p className="form-label text-left">{rdsTotal}</p>
                          </div>
                        </div>
                      }
                    </div>
                  )}
                  {key == "obj2" && (
                    <div>
                      <div className="form-group row mb-0 mt-0">
                        <div className="col-md-9 pl-0">
                          <TextareaElement
                            id="comments"
                            name="comments"
                            defaultValue={getValues("summary.client_desc")}
                            onChange={(e) => {
                              setValue("comments", e.target.value);
                            }}
                            className="w-full"
                            rows={5}
                            placeholder="Comments"
                          />
                        </div>
                        <div className="col pr-0">
                          <Controller
                            name="date"
                            control={control}
                            render={({ field }) => (
                              <CalendarElement
                                id="date"
                                {...field}
                                placeholder="Select Date"
                              />
                            )}
                          />
                        </div>
                        <div className="cancel-footer mt-20">
                          <div className="d-flex align-center justify-end pb-0">
                            <ButtonElement
                              className="save-button"
                              type="submit"
                              label="Save Data for set date"
                              onClick={save}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-20">
                        {clientLogData && clientLogData.length > 0 && (
                          <DataTable
                            value={clientLogData}
                            columns={columns}
                            removeField={removeField}
                            rowClick={rowClick}
                            dataKey="_id"
                            isNotReorder={true}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </AccordionTab>
              }
            </Accordion>
          </div>
        ))}
      </form>
      <Dialog
        header={"Upload Formatted spreadsheet"}
        visible={uploadPopup}
        position="top"
        onHide={onCloseUploadPopup}
        className="width-50vw"
        draggable={false}
      >
        <ExcelUploader
          onCloseUploadPopup={onCloseUploadPopup}
          refData={optionName}
        />
      </Dialog>
      {Object.keys(selectedHistoricData).length !== 0 && (
        <Dialog
          visible={historyPopup}
          header="Historic Data"
          onHide={onCloseHistoryPopup}
          breakpoints={{ "960px": "75vw" }}
          draggable={false}
          position="right"
          footer={renderFooter()}
        >
          <div>
            <p className="label-text">
              {
                _.find(props?.EsgPreviewScoreData?.clientSectionsSummary, {
                  section_name: "Criteria",
                })?.display_name
              }
            </p>
            {allRdsData.length > 0 &&
              allRdsData.map((item) => (
                <div className="form-group row align-items-center mb-0">
                  <div className="col-md-9 pl-0">
                    <p className="form-label text-left">{item.display_name}</p>
                  </div>
                  <div className="col pr-0 d-flex justify-center">
                    {item.field_type != "text" &&
                      Object.entries(selectedHistoricData?.rds?.rds_data).map(
                        ([key, value]) => {
                          if (key == item.field_name) {
                            return (
                              <p className="form-label text-left">{value}</p>
                            );
                          }
                        }
                      )}
                    {item.field_type == "text" &&
                      selectedHistoricData?.rds?.rds_score}
                  </div>
                </div>
              ))}
          </div>
          <div>
            <p className="label-text">
              {
                _.find(props?.EsgPreviewScoreData?.clientSectionsSummary, {
                  section_name: "Comments",
                })?.display_name
              }
            </p>
            <p className="form-label text-left">
              {selectedHistoricData?.dataTimePeriod?.comments}
            </p>
          </div>
        </Dialog>
      )}
      <Dialog id="videoModal" visible={showVideo}
        breakpoints={{
          '1200px': '80vw',    // Larger modal on bigger screens
          '1024px': '85vw',    // Slightly smaller for medium screens
          '769': '90vw',     // Responsive on tablets
          '641px': '95vw',     // Almost full-width on mobile
        }}
        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
      >
        <div className="video-overlay">
          <div className="video-container">
            <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_assessment_esg" />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EsgPreviewScore;
